<template>
  <v-row class="ma-0 inspectionDashboardContainer h-100 overflow-overlay">
    <v-col
      :sm="viewerOpened ? 8 : 12"
      v-if="!isViewerFullscreen"
      class="pa-0 overflow-y-auto h-100 overflow-overlay">
      <v-sheet class="pe-2 d-flex flex-column h-100">
        <div class="d-flex d-flex flex-column">
          <v-row class="ma-3">
            <v-col cols="6" class="px-3" v-if="viewerOpened">
              <v-card
                outlined
                three-line
                :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'"
                style="border-left: 4px solid #d2a000"
                class="h-100 d-flex align-center px-4 rounded-xl widget totalsCard" :class="{ 'selected-card-gold': inspectionDashboardSelectedCard === 'openStatus' }">
                <v-sheet class="rounded-pill iconContainer">
                  <v-img
                    src="@Assets/svgs/Simplification_yellow.svg"
                    width="50"
                    height="50"
                    contain />
                </v-sheet>
                <v-card-text class="h-100 pl-3 d-flex flex-column">
                  <v-row> 
                    <v-col class="d-flex justify-space-between">
                      <span @click="selectCard('openStatus')" class="totalNumber" style="cursor: pointer;">{{inspectionStats.openStatus}}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click.stop="resetFilters" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-col>  
                  </v-row>
                  <span class="text-h7"> Open status for more than 60 calendar days</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6" class="px-3 pe-0" v-if="viewerOpened">
              <v-card
                outlined
                three-line
                :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'"
                style="border-left: 4px solid #c04f15"
                class="h-100 d-flex align-center px-4 rounded-xl widget totalsCard" :class="{ 'selected-card-red': inspectionDashboardSelectedCard === 'prdOverhaul' }">
                <v-sheet class="rounded-pill iconContainer">
                  <v-img src="@Assets/svgs/Simplification_Red.svg" width="50" height="50" contain />
                </v-sheet>
                <v-card-text class="h-100 pl-3 d-flex flex-column">
                <v-row> 
                    <v-col class="d-flex justify-space-between">
                      <span @click="selectCard('prdOverhaul')" class="totalNumber" style="cursor: pointer;">{{ inspectionStats.prdOverhaul }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click.stop="resetFilters" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-col>  
                  </v-row>
                  <span class="text-h7"> PRD Overhaul date more than 10 years</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col :cols="viewerOpened ? 6 : 5" class="pa-0 pe-2">
              <v-sheet
                class="pa-3"
                style="box-shadow: 0px 0px 20px 0px #0000000d; border-radius: 10px">
                <v-card-title class="pa-0 py-2">
                  <span class="font-weight-bold" style="color: var(--v-grey-500-base)"
                    >Work Status</span
                  >
                  <v-chip v-if="workStatusCategory" label color=" " class="ml-2" x-small
                ><v-icon color="primary" class="mr-1" x-small>mdi-filter </v-icon>
                 {{ workStatusCategory  }} {{ workStatusStatus }}
                <v-btn icon @click="resetFilters()" class="pl-2" style="width: 20px">
                  <i class="fas fa-times" style="color: red"></i> </v-btn
              ></v-chip>

                  <!-- <v-spacer></v-spacer>
                  <v-btn color="primary" small outlined rounded @click="openFilters">
                    <v-icon left>mdi-filter</v-icon> Filters
                  </v-btn> -->
                </v-card-title>
                <v-data-table
                  @click:row="workStatusRowClicked"
                  class="workStatusTable"
                  :headers="headers"
                  :items="inspectionStats.items"
                  
                  hide-default-footer>
                  <template v-slot:item="{ item }">
                    <tr>
                      <td @click="workStatusRowClicked(item)">{{ item.category }}</td>
                      <td>{{ item.plan }}</td>
                      <td class="d-flex align-center" > 
                        <v-progress-linear
                          :size="35"
                          :rotate="-90"
                          class="d-flex justify-center"
                          :value="item.progress"
                          :color="progressColor(item.progress)">
                        </v-progress-linear>
                        <span
                          class="text-caption font-weight-bold mx-2"
                          style="color: var(--v-black-base)">
                          {{ item.progress }}%</span
                        >
                      </td>
                      <td @click="workStatusItemClicked(item,'Completed')">
                        <v-chip
                          color="success"
                          :value="item.completed"
                          class="rounded-lg justify-center font-weight-bold"
                          style="width: 65%;cursor: pointer;">
                          {{ item.completed }}
                        </v-chip>
                      </td>
                      <td @click="workStatusItemClicked(item,'Overdue')">
                        <v-chip
                          color="error"
                          :value="item.overdue"
                          class="rounded-lg justify-center font-weight-bold"
                          style="background-color: #e16868 !important; width: 65%;cursor: pointer;">
                          {{ item.overdue }}
                        </v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-sheet>
            </v-col>
            <v-col
              cols="3"
              class="pa-0 px-3 d-flex flex-column"
              style="gap: 20px"
              v-if="!viewerOpened">
              <v-sheet
                class="d-flex align-center totalsCard pa-3 h-100"
                style="position: relative"
                :class="{ 'selected-card-gold': inspectionDashboardSelectedCard === 'openStatus' }"
                :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'">
                <hr class="cardBar" style="background-color: #d2a000" />
                <div class="rounded-pill iconContainer me-4" style="background-color: #d2a0000d">
                  <img
                    width="50"
                    height="50"
                    src="@Assets/svgs/Simplification_yellow.svg"
                    alt="tab icon" />
                </div>
                <div class="d-flex flex-column flex-grow-1">
                  
                  <v-row> 
                    <v-col class="d-flex justify-space-between">
                      <span @click="selectCard('openStatus')" class="totalNumber" style="cursor: pointer;">{{inspectionStats.openStatus}}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click.stop="resetFilters" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-col>  
                  </v-row>
                  <p class="mb-0 font-weight-medium text-subtitle-2">
                    Open status for more than 60 calendar days
                  </p>
                </div>
              </v-sheet>
              <v-sheet
                class="d-flex align-center totalsCard pa-3 h-100"
                style="position: relative"
                :class="{ 'selected-card-red': inspectionDashboardSelectedCard === 'prdOverhaul' }"
                :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'">
                <hr class="cardBar" style="background-color: #c04f15" />
                <div class="rounded-pill iconContainer me-4" style="background-color: #c04f150d">
                  <img
                    width="45"
                    height="45"
                    src="@Assets/svgs/Simplification_Red.svg"
                    alt="tab icon" />
                </div>
                <div class="d-flex flex-column flex-grow-1">
                  <v-row> 
                    <v-col class="d-flex justify-space-between">
                      <span @click="selectCard('prdOverhaul')" class="totalNumber" style="cursor: pointer;">{{ inspectionStats.prdOverhaul }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn @click.stop="resetFilters" icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-autorenew</v-icon>
                          </v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-col>  
                  </v-row>

                  <p class="mb-0 font-weight-medium text-subtitle-2">
                    PRD Overhaul date more than 10 years
                  </p>
                </div>
              </v-sheet>
            </v-col>
            <v-col :cols="viewerOpened ? 6 : 4" class="pa-0">
              <DoughnutChart
                :title="'Inspection Results Overview'"
                :key="'inspection-results-overview'"
                :type="'doughnut'"
                :cutout="'50%'"
                :labels="{
                  padding: 20,
                }"
                :legendPosition="'bottom'"
                :canvasHeight="'255px'"
                :data="cathodicProtectionData"></DoughnutChart>
            </v-col>
          </v-row>
        </div>
        <div class="mx-3 flex-grow-1">
          <dashboard-grid
            ref="dashboardGrid"
            class="flex-grow-1"
            gridName="inspection"
            :viewerOpened="viewerOpened"
            @openViewer="openViewer"
            @reset="resetFilters()"
            :selectedFilters="selectedFilters" 
            :selectedRowsData.sync="selectedRowsData"
            :coloredInspections.sync="coloredInspections"></dashboard-grid>
        </div>
      </v-sheet>
    </v-col>
    <v-col
      :cols="isViewerFullscreen ? '12' : '4'"
      v-show="viewerOpened"
      class="pb-0 h-100 overflow-overlay"
      :class="{ absoluteViewer: isViewerFullscreen }">
      <viewers-section
        ref="viewersSection"
        :hide360View="true"
        :viewerTab.sync="viewerTab"
        @closeViewersSection="closeInspectViewer"
        @toggleFullscreen="toggleFullscreen">
      </viewers-section>
    </v-col>
    <!-- <DashboardFilters ref="dashboardFilters" :viewerOpened="viewerOpened"></DashboardFilters> -->
  </v-row>
</template>
<script>
  import { ForgeInspection } from '@/scripts/js/forgeModels';
  import DashboardGrid from '../components/DashboardGrid.vue';
  import DoughnutChart from '../components/doughnut-chart/DoughnutChart.vue';
  import ViewersSection from '../components/ViewersSection.vue';
  // import DashboardFilters from '../components/DashboardFilters.vue';
  import { log, warn, error } from '@/utils/debugLogger';

  export default {
    name: 'InspectionDashboard',
    data() {
      return {
        workStatusCategory:null,
        workStatusStatus:null,
        inspectionDashboardSelectedCard:null,
        viewerTab: '3D View',
        isViewerFullscreen: false,
        headers: [
          { text: 'Category', value: 'category' },
          { text: 'Plan', value: 'plan' },
          { text: 'Progress', value: 'progress' },
          { text: 'Completed', value: 'completed' },
          { text: 'Overdue', value: 'overdue' },
        ],
        selectedInspectionProperties: [],
      };
    },
    components: {
      DashboardGrid,
      ViewersSection,
      DoughnutChart,
      // DashboardFilters,
    },
    computed: {
      generalFilters: {
        get() {
          return this.$store.getters['DASHBOARD_FILTERS/GET_FILTERS'];
        },
      },
      selectedFilters() {
        return {
          category:this.workStatusCategory,
          status:this.workStatusStatus,
          inspectionDashboardSelectedCard:this.inspectionDashboardSelectedCard
        }
      },
      viewerOpened: {
        get() {
          return this.$store.getters['INSPECTION_DASHBOARD/GET_VIEWER_OPENED'];
        },
        set(value) {
          this.$store.commit('INSPECTION_DASHBOARD/SET_VIEWER_OPENED', value);
        },
      },
      coloredInspections: {
        get() {
          return this.$store.getters['INSPECTION_DASHBOARD/GET_COLORED_INSPECTIONS'];
        },
        set(value) {
          this.$store.commit('INSPECTION_DASHBOARD/SET_COLORED_INSPECTIONS', value);
        },
      },
      inspectionStats: {
        get() {
          return this.$store.getters['INSPECTION_DASHBOARD/GET_INSPECTION_STATS'];
        }
      },
      selectedRowsData: {
        get() {
          return this.$store.getters['INSPECTION_DASHBOARD/GET_SELECTED_ROWS_DATA'];
        },
        set(value) {
          this.$store.commit('INSPECTION_DASHBOARD/SET_SELECTED_ROWS_DATA', value);
        },
      },
      forgeService: {
        get() {
          return this.$store.state.forgeService;
        },
      },
      viewer() {
        return this.$store.state.viewer;
      },
      isAMIS() {
        return !!this.$store.state.forgeSettings?.isAMIS;
      },
    cathodicProtectionData() {
      return {
        labels: ['Reports Audited', 'Approvals', 'Pending Reports'],
        datasets: [
          {
            backgroundColor: ['#665B9B', '#00A8B7', '#D2A000'],
            data: this.inspectionStats.reportsData,
          },
        ],
      };

    }

  },
    activated() {
      if (this.viewerOpened) {
        this.openViewer();
      }
    },
    mounted() {
      let payload = { facilityId: this.$route.params.id };
     this.$store.dispatch('INSPECTION_DASHBOARD/GET_INSPECTION_STATS',payload);
    },
    methods: {
      selectCard(card) {
        log(card)
        this.inspectionDashboardSelectedCard = card;
        this.workStatusCategory=null;
        this.workStatusStatus=null  ;
      },
      resetFilters(){
        this.inspectionDashboardSelectedCard=null;
        this.workStatusCategory=null;
        this.workStatusStatus=null  ;
      },
      workStatusRowClicked(item){
        log(item);
        this.workStatusCategory=item?.category;
        this.workStatusStatus=null;
      },
      workStatusItemClicked(item,prop){
        this.workStatusCategory=item?.category;
        this.workStatusStatus=prop;
      },
      closeInspectViewer() {
        this.viewerOpened = false;
      },
      openViewer() {
        this.viewerOpened = true;
        this.handleViewerChange();
      },
      handleViewerChange() {
        if (this.viewerTab === '3D View') {
          this.handle3dViewer();
        } else if (this.viewerTab === '2D View') {
          this.handle2dViewer();
        }
      },
      handle3dViewer() {
        this.$refs.viewersSection.load3dViewer().then(() => {
          this.$refs.dashboardGrid.isolateSelectedInspection3d();
        });
      },
      handle2dViewer() {
        if (!this.viewerOpened) return;
        
        let selectedInspections = this.$refs.dashboardGrid.selectedColoredInspections;

        if (!Array.isArray(selectedInspections)) selectedInspections = [selectedInspections];

        if (selectedInspections.length === 0) {
          this.$dialog.notify.error('No inspection selected');
          return;
        }

        selectedInspections = selectedInspections.map((o) => {
          if (o instanceof ForgeInspection) {
            return o;
          } else {
            let e = Object.assign(new ForgeInspection(), o);
            e.parseContent();
            return e;
          }
        });

        this.handleIsolateMatchedInspections2d(selectedInspections);
      },
      async handleIsolateMatchedInspections2d(inspections) {
        let points = inspections.map((o) => o?.point).filter((o) => o);

        let levelsSet = new Set(points.map((o) => this.forgeService.getLevelContainsPoint(o)));

        let levels = Array.from(levelsSet).filter((o) => o);

        let level = levels.length == 1 ? levels[0] : this.$store.state.levels[0];

        if (levels.length > 1) {
          error('Multiple levels found', levels);
          this.$dialog.notify.warning('Multiple levels found');
        }

        this.$store.state.selectedLevel = level;

        if (!level?.planUrn) {
          error('Plan URN not found', level);
          this.$dialog.notify.error('Plan URN not found');
          this.$refs.viewersSection.viewerState.isLoading = false;
          return;
        }

        this.$refs.viewersSection.load2dViewer(level.planUrn).then(() => {
          // this.forgeService.zoomToPoints2D(points);
          this.forgeService.getLabels2DExtension().clear3DTags();
          this.forgeService.getLabels2DExtension().createHighlightingTags(inspections);
          this.$refs.viewersSection.viewerState.isLoading = false;
        });
      },
      toggleFullscreen(event) {
        this.isViewerFullscreen = event;
        this.$store.commit('SET_VIEW_1_TYPE', '3d');
        this.$store.commit('SET_IS_VIEW_1_VISIBLE', true);
        this.$store.commit('SET_IS_VIEW_2_VISIBLE', false);
        this.$store.commit('SET_IS_VIEW_3_VISIBLE', false);
        this.$store.commit('SET_IS_VIEW_4_VISIBLE', false);
        this.$router.push({
          name: 'facility',
          query: {},
        });
      },
      progressColor(progress) {
        if (progress >= 80) {
          return 'success';
        } else if (progress >= 50) {
          return 'warning';
        } else {
          return 'error';
        }
      },
      // openFilters() {
      //   this.$refs.dashboardFilters.open();
      // },
    },
    watch: {
      viewerOpened() {
        this.$emit('viewerOpened', this.viewerOpened);
      },
      viewerTab: {
        handler: function () {
          this.handleViewerChange();
        },
      },
    },
  };
</script>

<style lang="scss">
  .customSearchBox {
    .v-input__control .v-input__slot {
      padding-right: 5px;
      .v-input__append-inner {
        margin-top: 5px !important;
        .v-input__icon--append {
          border-radius: 50%;
          background-color: var(--v-primary-base);
          width: 30px;
          height: 30px;
          i {
            color: var(--v-white-base);
          }
        }
      }
    }
  }

  .activeTab {
    border: 1px solid var(--v-primary-base);
    background-color: var(--v-white-base) !important;
  }

  .custom-tabs {
    .v-tab {
      color: var(--v-primary-base) !important;
    }
    .v-tab--active {
      color: inherit;
    }
  }
  .customBoxShadow {
    box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
      0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important;
  }
  .v-list-item::not {
    border-bottom: 1px solid var(--v-grey-500-lighten4);
  }
  .notSelectedChip {
    background-color: #edf2e8 !important;
    // background-color: var(--v-light-grey2-base) !important;
    // color: var(--v-primary-base) !important;
  }
  .selectedChip {
    background-color: #edf2e8 !important;
    color: var(--v-primary-base) !important;
    border: 2px solid var(--v-primary-base);
  }

  .option-input-wrapper input {
    width: 50px;
    height: 35px;
    border: none;
    padding: 0px;
    background-color: transparent;
  }
  .theme--dark .option-input-wrapper input {
    color: var(--v-bg_force_white-base);
  }

  .LastInspectionsToggle {
    & .v-btn {
      color: var(--v-primary-base) !important;
      text-transform: none !important;
      background-color: #edf2e8 !important;
      letter-spacing: normal !important;
      font-weight: 600;
      border: none;

      & i {
        color: var(--v-primary-base) !important;
      }

      &:hover:before {
        background-color: var(--v-primary-base);
      }

      &.v-btn--active {
        color: white !important;
        box-shadow: none !important;

        & i {
          color: white !important;
        }

        &:before {
          background-color: var(--v-primary-base);
          opacity: 1;
        }
      }
    }
  }

  .hasValue {
    background-color: var(--v-light_Primary-base);
  }
  .v-chip-custom {
    font-size: 11px;
    height: 27px;
    width: 27px;
    text-align: center;
    .v-chip__content {
      justify-content: center;
    }
  }
  .absoluteViewer {
    position: absolute;
    top: 0;
    left: 0;
    height: 100vh;
  }
  .totalCard {
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05) !important;

    border-radius: 7px;
    cursor: pointer;
  }
  .RemainingLife {
    &:hover {
      background-color: #efeff5;
    }
  }
  .TMin {
    &:hover {
      background-color: #ecf1f5;
    }
  }
  .tminActive {
    &:hover {
      background-color: #ecf1f5 !important;
    }
  }
  .remainingLifeActive {
    &:hover {
      background-color: #efeff5 !important;
    }
  }

  .totalResult {
    font-size: 24px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.4px;
    color: var(--v-grey-500-base);
  }
  .inspectionDashboardContainer .iconContainer {
    width: 78px;
    height: auto;
    padding: 10px;
    gap: 10px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .inspectionDashboardContainer .totalsCard {
    box-shadow: 0px 0px 20px 0px #0000000d;
    border-radius: 10px;

    &.selected-card-gold {
      box-shadow: 0px 0px 20px 0px rgba(210, 160, 0, 0.5);
    }

    &.selected-card-red {
      box-shadow: 0px 0px 20px 0px rgba(192, 79, 21, 0.5);
    }
  
    .totalNumber {
      font-size: 28px;
      font-weight: 600;
      line-height: 42px;
      color: var(--v-grey-500-darken1);
    }
    .cardBar {
      position: absolute;
      top: 0px;
      left: 15%;
      height: 4px;
      width: 70%;
      border-style: none;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;
    }
  }

  .workStatusTable {
    // th,
    // td {
    //   text-align: center !important;
    // }
    thead {
      background-color: var(--v-colored_bg-base);
      border-radius: 8px;
      th:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      th:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
      th {
        border-bottom: none !important;
        text-align: center !important;
      }
    }
    tbody {
      > tr {
        margin-bottom: 10px;
      }
      tr {
        margin: 5px 0px;
        // box-shadow: 0px 0px 20px 0px #0000000d;
        cursor: pointer;

        td {
          // padding: 5px 16px !important;
          border-bottom: 5px solid#0000000d !important;
        }
      }
    }
  }
</style>
